import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Tabs } from '@gem/ui-kit';

import { EmojiPanel } from './EmojiPanel/EmojiPanel';
import { useEmojiStickersPanelPresenter } from './EmojiStickersPanel.presenter';
import { StickerPanel } from './StickerPanel/StickerPanel';
import styles from './styles.m.css';

const TABS = [EmojiPanel, StickerPanel];

interface IEmojiStickersPanelProps {
  closePopover(): void;
}
export const EmojiStickersPanel: FC<IEmojiStickersPanelProps> = observer(({ closePopover }) => {
  const presenter = useEmojiStickersPanelPresenter();

  const TabContent = TABS[presenter.activeTab];

  return (
    <div className={styles.container}>
      <Tabs
        className={styles.tabs}
        tabs={presenter.tabs}
        selectedTabIndex={presenter.activeTab}
        onChange={presenter.setActiveTab}
      />
      <TabContent closePopover={closePopover} />
    </div>
  );
});
